export default __webpack_public_path__ + "static/media/3_template.1ee8a208.svg";